/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Update_FieldInputs */

const cs_action_update_field = /** @type {(inputs: Action_Update_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizovat pole`)
};

const en_action_update_field = /** @type {(inputs: Action_Update_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update field`)
};

/**
* | output |
* | --- |
* | "Update field" |
*
* @param {Action_Update_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_update_field = /** @type {((inputs?: Action_Update_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Update_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_update_field(inputs)
	return cs_action_update_field(inputs)
});